import React from "react";
import {
  MapPin,
  FileText,
  ShieldCheck,
  Hammer,
  BadgeCheck,
  HeartHandshake,
} from "lucide-react";

const items = [
  {
    icon: MapPin,
    title: "Local Experience & Knowledge",
    description:
      "We're familiar with the local climate, building codes, weather challenges (snow, storms, seasonal shifts).",
  },
  {
    icon: FileText,
    title: "Transparent Quotes",
    description:
      "We provide free, no-obligation estimates so you can see the cost ahead of time.",
  },
  {
    icon: ShieldCheck,
    title: "Licensed And Insured",
    description:
      "We are fully licensed in Michigan, with liability and workers' compensation insurance.",
  },
  {
    icon: Hammer,
    title: "Quality Materials & Installation",
    description:
      "We partner with good manufacturers (e.g. GAF shingles) and use materials built to withstand Michigan's weather.",
  },
  {
    icon: BadgeCheck,
    title: "Warranty & Guarantees",
    description:
      "We offer manufacturer warranties and our own workmanship guarantee.",
  },
  {
    icon: HeartHandshake,
    title: "Customer-Focused Service",
    description:
      "Clean-up, respect for the property (landscaping, etc.), good communication.",
  },
];

const WhyRoachStandsOut = ({ city }) => {
  const location = city ? city : "Your Area";

  return (
    <section className="py-16 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-center text-2xl md:text-3xl font-display font-extrabold uppercase tracking-wide text-neutral-900 mb-10">
          Why Roach Home Stands Out In {location}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(({ icon: Icon, title, description }, i) => (
            <div
              key={i}
              className="bg-neutral-100 rounded-2xl p-6 md:p-8 shadow-sm"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white mb-5">
                <Icon size={22} className="text-neutral-800" />
              </div>
              <h3 className="font-display font-bold text-lg text-neutral-900 mb-2">
                {title}
              </h3>
              <p className="text-neutral-600 leading-relaxed">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyRoachStandsOut;
